import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextInput, TextInputProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type SearchTableInputPropsType = {
  search: string;
  setSearchValue: (search: string) => void;
} & TextInputProps;

export const SearchTableInput: React.FC<SearchTableInputPropsType> = ({
  search,
  setSearchValue,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <TextInput
      size="xs"
      placeholder={t('SEARCH_PLACEHOLDER')}
      rightSection={<FontAwesomeIcon icon={faSearch} />}
      role="search"
      onChange={(e) => setSearchValue(e.target.value)}
      defaultValue={search}
      {...props}
    />
  );
};
